// extracted by mini-css-extract-plugin
export default {"topSection":"TopSection-module__topSection__0aTJt"};